import { propOr } from 'ramda';
import * as moment from 'moment';

export const niubizResponseResolver = ({ raw }: any): NiubizResponse => {
  const getFrom = (defaultValue, field) => propOr(defaultValue, field, raw);

  return {
    currencyCode: getFrom('', 'CURRENCY'),
    transactionDate: getFrom('', 'TRANSACTION_DATE'),
    transactionDateFormatted: moment(
      getFrom('', 'TRANSACTION_DATE'),
      'x'
    ).format('DD MMM YYYY hh:mm a'),
    actionCode: getFrom('', 'ACTION_CODE'),
    actionDescription: getFrom('', 'ACTION_DESCRIPTION'),
    eciDescription: getFrom('', 'ECI_DESCRIPTION'),
    brand: getFrom('', 'CARD'),
    cardNumber: getFrom('', 'CARD'),
    status: getFrom('', 'STATUS'),
    id: getFrom('', 'ID_UNICO'),
    amount: getFrom('', 'AMOUNT'),
    transactionId: getFrom('', 'TRANSACTION_ID'),
    processCode: getFrom('', 'PROCESS_CODE'),
    authorizationCode: getFrom('', 'AUTHORIZATION_CODE'),
  };
};
